import { Controller } from 'stimulus'
import Rails from "@rails/ujs"
import FingerprintJS from '@fingerprintjs/fingerprintjs';

export default class extends Controller {
  static targets = ['validatable']
  static classes = ['invalid']
  static values = { fingerprint: Boolean }

  connect() {
    if (this.invalidClass) {
      this.bindInputEvents()
    }
    if (this.fingerprintValue) {
      this.setFp()
      this.element.addEventListener('submit', this.addFp.bind(this))
    }
  }

  validate(e) {
    const errors = Array.from(this.element.querySelectorAll('.' + this.invalidClass))
    errors.forEach((element) => element.classList.remove(this.invalidClass))

    for(const element of this.validatableTargets) {
      let message = null
      if (element.nodeName == 'INPUT' && element.type == 'checkbox' && !element.checked) {
        message = 'Необходимо отметить'
      } else if (element.nodeName == 'INPUT' && element.type == 'email' && !this.checkEmail(element.value)) {
        message = 'Неверный формат'
      } else if (element.nodeName == 'INPUT' && !element.value) {
        message = 'Заполните все поля'
      }
      if (!message) continue

      element.parentNode.classList.add(this.invalidClass)
      element.parentNode.setAttribute('data-error', message)
      element.focus()
      element.scrollIntoView({ block: 'center', behavior: 'smooth' });
      e.preventDefault()
      e.stopPropagation()
      return
    }
  }

  bindInputEvents() {
    const inputs = Array.from(this.element.querySelectorAll('input'))
    inputs.forEach(el => el.addEventListener('keyup', () => {
      el.parentNode.classList.remove(this.invalidClass)
    }))
  }

  checkEmail(value) {
    return value.toLowerCase().match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )
  }

  enableSubmit(e) {
    this.element.querySelector('input[type="submit"]').disabled = false
  }

  disableSubmit(e) {
    this.element.querySelector('input[type="submit"]').disabled = true
  }

  setFp = async () => {
    const fp = await FingerprintJS.load()
    const { visitorId } = await fp.get()
    this.visitorId = visitorId
  }

  addFp(e) {
    e.preventDefault()
    e.stopPropagation()

    let data = new FormData(this.element)
    data.append('fp', this.visitorId)
    // fetch(this.element.action, {
    //   method:'post',
    //   credentials: 'same-origin',
    //   body: data
    // })

    Rails.ajax({
      url: this.element.action,
      type: 'post',
      data: data,
      accept: 'js',
      dataType: 'script'
    })
  }
}
